import { Card } from "@/components/ui/card";
import React from "react";
import BusinessUnitTableView from "./table";
import useDocumentTitle from "@/components/ui/common/document-title";

const BusinessUnit = () => {
    useDocumentTitle("Business Units");

    return (
        <div className="w-full p-5">
            <Card className="pt-4">
                <BusinessUnitTableView />
            </Card>
        </div>
    );
};

export default BusinessUnit;
